import Button from "@mui/material/Button";
import ButtonNodeType from "../../types/ButtonNodeType";

const ButtonNode = ({ isSubmitting, children, variant, color, onClick, ...props }: ButtonNodeType) => {
  return (<>
    <Button
      variant={variant ?? "outlined"}
      color={color ?? "primary"}
      disabled={isSubmitting}
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
  </>);
};

export default ButtonNode;
